import { Alert, AlertType } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '~/components/icon/Icon';

import styles from './InlineAlert.module.scss';

export interface InlineAlertProps {
  alertType?: 'exceededLimit' | 'onlyOneSource';
  type?: AlertType;
  message?: string;
}

export const InlineAlert = ({
  alertType,
  type = AlertType.Info,
  message,
}: InlineAlertProps) => {
  const { t } = useTranslation(['chat']);
  const isInfo = type === AlertType.Info;

  const alertMessage =
    alertType === 'exceededLimit'
      ? t('chat:trustedSources.modal.exceededLimit')
      : t('chat:trustedSources.modal.onlyOneSource');

  return (
    <Alert
      className={styles.alert}
      type={type}
      variant={isInfo ? 'inline' : undefined}
      message={message ?? alertMessage}
      customIcon={
        isInfo ? (
          <Icon
            fillColor="var(--icon-primary)"
            iconName="InformationCircle"
            size={20}
          />
        ) : undefined
      }
    />
  );
};
